import { GroupedPermissions, PermissionNew } from "../type";

export const groupPermissionsByCategory = (
  permissions: PermissionNew[],
): GroupedPermissions => {
  return permissions.reduce((acc: GroupedPermissions, perm: PermissionNew) => {
    if (!acc[perm.category]) {
      acc[perm.category] = {};
    }
    if (!acc[perm.category][perm.subCategory]) {
      acc[perm.category][perm.subCategory] = [];
    }

    // Determine if the permission is a route
    const isRoute = !!perm.children?.length;

    // If the permission has children, add `isRoute: true`
    if (isRoute) {
      const routePermission = { ...perm, isRoute: true };
      delete routePermission.children; // Remove children from the route permission object
      acc[perm.category][perm.subCategory].push(routePermission);

      // Also add the children to the respective subCategorycategory
      perm.children?.forEach((child) => {
        acc[perm.category][child.subCategory] =
          acc[perm.category][child.subCategory] || [];
        acc[perm.category][child.subCategory].push({
          ...child,
          isRoute: false,
        }); // Children are not routes
      });
    } else {
      // If no children, `isRoute: false`
      acc[perm.category][perm.subCategory].push({ ...perm, isRoute: false });
    }

    return acc;
  }, {});
};
